import { Instagram, Mail, MapPin, Phone } from "lucide-react";
import { LogoMark } from "@/components/Logo";
import { COLLECTIONS, CONTACT, INSTAGRAM, POLICIES, SHOP, collectionUrl } from "@/data/catalog";
import { useLiveMeta } from "@/lib/live";

const Col = ({ title, children }) => (
  <div>
    <p className="mb-5 font-mono text-xs uppercase tracking-[0.25em] text-champagne">{title}</p>
    <ul className="space-y-3 text-sm text-stone">{children}</ul>
  </div>
);

const SyncNote = () => {
  const { fetchedAt } = useLiveMeta();
  return (
    <p className="font-mono uppercase tracking-[0.2em]" data-testid="footer-sync-note">
      {fetchedAt ? `Prices & stock synced from acevanity.in · ${new Date(fetchedAt).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}` : "Pressed light, worn like a secret"}
    </p>
  );
};

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-gold/15 pt-20">
    <div className="mx-auto grid max-w-[1440px] gap-12 px-5 sm:grid-cols-2 sm:px-8 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-4">
        <LogoMark className="h-12 w-12 text-champagne" />
        <p className="mt-6 max-w-xs text-sm leading-relaxed text-stone">The Beauty Edit by Ace Vanity. WINK eye colour and lashes, chosen for artists and the people they make up.</p>
        <a href={INSTAGRAM} target="_blank" rel="noreferrer" data-testid="footer-instagram-link" className="mt-6 inline-flex items-center gap-2 text-sm text-cream hover:text-champagne">
          <Instagram className="h-4 w-4" /> @acevanity1
        </a>
      </div>
      <div className="lg:col-span-3">
        <Col title="The Edit">
          {COLLECTIONS.map((c) => (
            <li key={c.slug}>
              <a href={collectionUrl(c.handle)} data-testid={`footer-collection-${c.slug}`} className="footer-link">{c.name}</a>
            </li>
          ))}
        </Col>
      </div>
      <div className="lg:col-span-2">
        <Col title="Help">
          {POLICIES.map((p) => (
            <li key={p.label}>
              <a href={p.href} className="footer-link" data-testid={`footer-policy-${p.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{p.label}</a>
            </li>
          ))}
          <li><a href={`${SHOP}/collections/all`} className="footer-link" data-testid="footer-all-products">All products</a></li>
        </Col>
      </div>
      <div className="lg:col-span-3">
        <Col title="Visit & contact">
          <li className="flex gap-3"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-champagne" />{CONTACT.address}</li>
          <li><a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} data-testid="footer-phone" className="footer-link inline-flex gap-3"><Phone className="h-4 w-4 text-champagne" />{CONTACT.phone}</a></li>
          <li><a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="footer-link inline-flex gap-3"><Mail className="h-4 w-4 text-champagne" />{CONTACT.email}</a></li>
        </Col>
      </div>
    </div>
    <div className="mx-auto mt-16 flex max-w-[1440px] flex-wrap justify-between gap-4 px-5 text-xs text-stone sm:px-8 lg:px-12">
      <p>© {new Date().getFullYear()} Ace Vanity. All rights reserved.</p>
      <SyncNote />
    </div>
    <p aria-hidden className="footer-wordmark mt-6 select-none whitespace-nowrap text-center font-display font-light leading-[0.78] text-transparent">
      Beauty Edit
    </p>
  </footer>
);
